import type { SolutionSector } from "../sectors";
import { ASK_LINE, LOGO } from "./shared";

export const FRACTIONAL: SolutionSector = {
  slug: "fractional",
  name: "Fractional finance & operations",
  demoOrg: "Demo (Fractional)",
  story: "fractional",
  metadata: {
    title: "AI for fractional CFOs and COOs | Your Twin",
    description:
      "Arrive at each client’s monthly review with the picture ready. Your Twin connects the client’s Xero, Google Sheets and Outlook records into one review.",
  },
  hero: {
    label: "Fractional finance & operations",
    title: ["Arrive with", "the picture.", "Not the prep."],
    lead: [
      "Spend less time rebuilding each client’s picture. Your Twin connects a client’s ",
      LOGO.xero,
      " records, ",
      LOGO.sheets,
      " trackers and ",
      LOGO.outlook,
      " conversations, so the monthly review starts with the decisions that need the client’s attention.",
    ],
    cta: "Bring a client review",
    buyer: "For fractional CFOs, fractional COOs and the advisers who run monthly client reviews",
    instrumentLabel: "The client Twin · Item, figure, question and owner",
    legendLines: [
      "Read the client’s Xero, Google Sheets and Outlook.",
      "Link each review item to its bills, invoices and emails.",
      "Build one picture of the client’s month.",
      "Check the connections and figures against the client’s records.",
      "Have agents prepare the monthly review and flag open questions.",
      "Save their work in shared channels: review items and open questions.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "What’s still open\nbefore the review?",
    lead: "Ask across the client’s Xero, checklist and email. See each open question beside its figure and owner.",
  },
  outcomes: {
    title: "The picture ready\nbefore the meeting.",
    lead: "Spend the client’s time on the decisions, not on rebuilding the numbers.",
    items: [
      { title: "Prepare from the records.", body: "Bring figures and explanations into the same review.", show: "sources" },
      { title: "Keep open questions visible.", body: "See what still needs the client’s input.", show: "status" },
      { title: "Reuse the review.", body: "Agree a repeatable format for each client’s monthly meeting.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose the monthly review you prepare for one client." },
  questions: [
    {
      q: "Can I see every client in one dashboard?",
      a: "This example is one client’s Twin. Access across client organisations isn’t assumed; it needs a separately agreed setup.",
    },
    { q: "Who holds the subscription?", a: "Agree the client, contract and access with Mercury Labs. One subscription doesn’t cover a portfolio of clients." },
    { q: "Can I include this in my service?", a: "Discuss a partnership with Mercury Labs. Delivery, support and commercial terms are agreed separately." },
  ],
  closing: "Bring the review you prepare\nfor one client every month.",
};
